import { merge, timer } from "rxjs";
import { filter, mapTo, retry, switchMap } from "rxjs/operators";
import { TypeActionScene } from "../../../scenes/actionScenes";
import { IdScene } from "../../../scenes/types/IdScene";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
var clientFunnelTimeStreamData = [
    { eventTime: "0_5", time: 30000 },
    { eventTime: "1", time: 60000 },
    { eventTime: "2", time: 120000 },
    { eventTime: "5", time: 300000 },
    { eventTime: "10", time: 600000 },
    { eventTime: "15", time: 900000 },
    { eventTime: "30", time: 1800000 },
    { eventTime: "45", time: 2700000 },
    { eventTime: "60", time: 3600000 },
];
export var epicGameTrackingClientFunnelPlayTime = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionScene.RequestSwap &&
            action.sceneId === IdScene.PlayerBase;
    }), switchMap(function () {
        var mapClientFunnelTimeStateToStream = function (val) {
            return timer(val.time).pipe(mapTo(actionGameTrackingUpdateClientFunnel(IdGameTrackingClientFunnelState.PLAY_TIME_X_MINUTE.replace("{X}", val.eventTime))));
        };
        var timeStream = clientFunnelTimeStreamData.map(mapClientFunnelTimeStateToStream);
        return merge.apply(void 0, timeStream);
    }), retry());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelPlayTime.ts
// module id = 1872
// module chunks = 3